import styled from 'styled-components';

export const Item = styled.div`
    display: flex;
`;

export const ItemTitle = styled.div`
    flex: 1;
    line-height: 43px;
`;